import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { AvtListesComponent } from '../avt-listes/avt-listes.component';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { GeneralService } from '../services/general.service';
import { AvtEchangeComponent } from '../avt-echange/avt-echange.component';
import { AvtDialogDeleteComponent } from '../avt-dialog-delete/avt-dialog-delete.component';
import { ListeComponent } from '../liste/liste.component';

@Component({
  selector: 'app-avt-liste-echange',
  templateUrl: './avt-liste-echange.component.html',
  styleUrls: ['./avt-liste-echange.component.scss']
})
export class AvtListeEchangeComponent implements OnInit {

  constructor(public dialog: MatDialog,public generalService :GeneralService) { }
  //@ViewChild//
  @ViewChild("listeEchangesComponen" ,{static:false}) listeEchangesComponen : ListeComponent;
  @Input() code : string = "";
  @Input() type : string = "";
  @Input() disabled : boolean = false
  @Input() heightTable  = 400;
  datasourceEchanges;
  datasourceEchangesIsLoadet : boolean = false;
  listBtnEchanges:Array<any> = []
  list_Btn_Echanges:Array<any> = [{name:"ajouterEchange",class:"colorBlue",text:"Ajouter",icon:"add"},
                                 {name:"modifierEchange",class:"colorGreen",text:"Modifier",icon:"edite"},
                                 {name:"supprimerEchange",class:"colorRed",text:"Supprimer",icon:"delete"}]
                                 
  list_Btn_Echanges2:Array<any> = [{name:"ficheProspect",class:"colorBlue",text:"Fiche prospect",icon:"liste"}]
                               
  columnsEchanges;
  columnsEchangesIsLoadet : boolean = false;
  disabledEchanges : boolean = true;
  showTabEchange : boolean = false;
  showDocEchange : boolean = false;
  CRMActivity_Id : string = "";
  exist : boolean = true;
  ngOnInit() 
  {
    this.datasourceEchanges = []
    if(!this.disabled)
    {
      if(this.code)
        this.listBtnEchanges = this.list_Btn_Echanges;
      else
        this.listBtnEchanges = this.list_Btn_Echanges2
    }
    else
      this.listBtnEchanges = []
    this.getEchange();
    this.initListBtnEchanges()
  }
  initListBtnEchanges()
  {
    this.listBtnEchanges.forEach(btn =>
    {
      btn.disabled = this.disabled;  
    });
    
  }
  getEchange()
  {
      this.getDataEchanges();
      this.getColumnsEchanges();
  }
  getDataEchanges()
  {
    var url = "";
    if(this.code) 
      url = this.generalService.urlListeCRMActivity+this.code
    else
    {
     //if(this.generalService.isNotEmpty(this.generalService.userPerso))
      {
        url = "recherche/tbdata?tablere=avtCRMActivity2";
      }
      
    }
    this.generalService.rechercheTable(url).subscribe(data =>
    {
      this.datasourceEchanges = data;
      this.datasourceEchangesIsLoadet = true;
      this.sortEchange();
      if(this.columnsEchangesIsLoadet)
      {
        this.showTabEchange = true;
        setTimeout( () => 
        {
          // this.listeEchangesComponen.setDataSource(data)
        },10);
      }
    })
  }

  getColumnsEchanges()
  {
    var url = this.generalService.urlColumnCRMActivity
    if(this.generalService.isEmpty(this.code))
      url = "recherche/TbRecherche?param=avtCRMActivity2"
    this.generalService.rechercheTable(url ).subscribe(data =>
    {  
      this.columnsEchangesIsLoadet = true; 
      this.columnsEchanges = data;
      this.columnsEchanges.TableRD.forEach(col =>
      {
        col.TableRD_ReadOnly = true;
      });
      if(this.type == "collaborateur")
      {
        this.columnsEchanges.TableRD = this.columnsEchanges.TableRD.filter(col => {return col.TableRD_Champs != "TiersC_Nom" && col.TableRD_Champs != "TiersC_PreNom"})
      }
      if(this.datasourceEchangesIsLoadet)
      {
        this.showTabEchange = true;
        setTimeout( () => 
        {
          // this.listeEchangesComponen.setDataSource(this.datasourceEchanges)
        },10);
      }
        
    });
  }

  showEchange(CRMActivity_Id)
  {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = true;
    dialogConfig.data={CRMActivity_Id:CRMActivity_Id,Tiers_code:this.code,type:this.type}          
    var dialogRef = this.dialog.open(AvtEchangeComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result =>
    {
      if(result.status)
      {        
        this.getDataEchanges();
        this.generalService.dialogSuccess("Échange enregistrer",true);
      }
      else
      {
        this.generalService.dialogSuccess("Échange non enregistrer",false)
      }
    });  
  }
  sortEchange()
  {
    this.datasourceEchanges.sort(function(a,b)
    {
      return new Date(b.CRMActivity_Date).getTime() - new Date(a.CRMActivity_Date).getTime();
    });
  }
  actionEchange(event)
  {
    if(event.action="clickBtnHeat")
    {
      if(event.bouton.name == "ficheProspect") 
        if(event.liste.row)
          this.generalService.popupCenter("/w/avt/client" + "/" + event.liste.row.Tiers_code + "/2/2")
        else
          this.generalService.dialogSuccess("Veuillez sélectionner une ligne",false);
      if(event.bouton.name == "ajouterEchange") 
        this.showEchange("-1")
      if(event.bouton.name == "modifierEchange") 
        if(event.liste.row)
          this.showEchange(event.liste.row.CRMActivity_Id)
        else
          this.generalService.dialogSuccess("Veuillez sélectionner une ligne",false);
      if(event.bouton.name == "supprimerEchange") 
        if(event.liste.row)
          this.supprimerEchanges(event.liste.row)
        else
          this.generalService.dialogSuccess("Veuillez sélectionner une ligne",false);
    }
  }
  clickBtnHeat(event)
  {
    switch (event.name)
    {      
      case "ajouterEchange":
      {
        this.showEchange("-1")
        break;
      }
      case "modifierEchange":
      {
        this.showEchange(event.row.CRMActivity_Id)
        break;
      }
      case "supprimerEchange":
      {
        this.supprimerEchanges(event.row)
        break;
      }
      case "selectRow":
      {
        this.getDocEchange(event.row.CRMActivity_Id)
        break;
      }
    }
  }
  getDocEchange(CRMActivity_Id)
  {
    this.showDocEchange = false;
    this.CRMActivity_Id = CRMActivity_Id; 
    setTimeout( () => 
    {
      this.showDocEchange = true
    },100);
  }
  supprimerEchanges(row)
  {
    const dialogConfig = this.generalService.dialogConfig;
      dialogConfig.autoFocus = true;
      var dialogRef = this.generalService.dialog.open(AvtDialogDeleteComponent, dialogConfig);
      dialogRef.afterClosed().subscribe(result =>
      {
        if(result == "supprimer")
        {
          var deleteFn = this.generalService.supprimerSanMsgConfirm(row.CRMActivity_Id,"crmactivity");
          if(deleteFn != null)
          {
            this.exist = false;
            this.listBtnEchanges[2].disabled = true
            deleteFn.subscribe(data => 
            {
              this.getDataEchanges();
              this.getDocEchange(-1);
              this.getDocEchange(null)
              this.generalService.dialogSuccess("Elément supprimer",true);
              this.exist = true;
              this.listBtnEchanges[2].disabled = false;
            },
            error =>
            {
                this.generalService.dialogSuccess("Elément non supprimé",false);
                this.exist = true;
                this.listBtnEchanges[2].disabled = false;
            });
          }
        }
        if(result == "annuler")
        {
        }
      });

  }
}
